export const safeDivision = (numerator, denominator) => {
  if (Number(denominator) === 0) return 0

  return Number(numerator) / Number(denominator)
}

export const safePercentage = (numerator, denominator) => {
  if (Number(denominator) === 0) return 0

  return (Number(numerator) / Number(denominator)) * 100
}
